var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18118 2.02429L9.16424 3.90991C9.23736 4.04872 9.34233 4.16823 9.47054 4.25864C9.59876 4.34906 9.74657 4.40782 9.90187 4.4301L11.9782 4.71447C13.0886 4.8676 13.5191 6.23654 12.6979 6.99779L11.2761 8.30985C11.1549 8.42122 11.0639 8.5615 11.0116 8.71759C10.9594 8.87367 10.9475 9.04045 10.9772 9.20235L11.3242 11.1265C11.5171 12.1983 10.4019 13.034 9.42324 12.544L7.43874 11.5596C7.30212 11.4927 7.15203 11.458 6.99993 11.458C6.84783 11.458 6.69774 11.4927 6.56112 11.5596L4.57662 12.544C3.59749 13.0296 2.48274 12.1983 2.67568 11.1265L3.02262 9.20191C3.08387 8.87379 2.97012 8.53691 2.72424 8.30941L1.30193 6.99779C0.480743 6.24091 0.911242 4.86716 2.02162 4.71404L4.09799 4.42966C4.25375 4.40877 4.40215 4.35057 4.53058 4.26C4.659 4.16943 4.76365 4.04918 4.83562 3.90947L5.81912 2.02429C6.31962 1.07491 7.68462 1.07491 8.18074 2.02429H8.18118Z",
    fill: "#FCD53F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e0cdd7fcd891ffb0377c90599438d4d5.svg";
export { ForwardRef as ReactComponent };